var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-autocomplete",
    {
      ref: "autoComplete",
      staticClass: "ui-autocomplete",
      class: { "md-invalid": _vm.errorMessage },
      attrs: {
        "md-fuzzy-search": false,
        "md-open-on-focus": false,
        "md-options": _vm.options,
        "md-input-placeholder": _vm.placeholder,
        required: _vm.required,
        value: _vm.value,
        autocomplete: "off",
      },
      on: {
        input: function ($event) {
          _vm.$emit(
            "input",
            _vm.trim && typeof $event === "string" ? $event.trim() : $event
          )
        },
        "md-changed": function ($event) {
          return _vm.$emit("change", $event)
        },
        "md-opened": _vm.setStyles,
        "md-selected": _vm.selected,
      },
      nativeOn: {
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.$emit("enter")
        },
      },
    },
    [
      _c("label", [_vm._v(_vm._s(_vm.label))]),
      _vm._v(" "),
      _vm.errorMessage
        ? _c("span", { staticClass: "md-error" }, [
            _vm._v(_vm._s(_vm.errorMessage)),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }